<template>
  <div class="row">
    <div class="col-md-4">
      <div class="form-group">
        <label>Название на платформе</label>
        <input v-model="taskData.drugDetails.title" type="text" class="form-control">
      </div>
      <div class="form-group">
        <label>Название на английском</label>
        <input v-model="taskData.drugDetails.en_title" type="text" class="form-control">
      </div>
      <div class="form-group">
        <label>Приоритет</label>
        <select v-model="taskData.drugDetails.priority" class="form-control">
          <option v-for="i in 5" :value="i">{{ i }}</option>
        </select>
      </div>
    </div>
    <div class="col-md-4">
      <div class="form-group">
        <label>ЕГК</label>
        <EgkSelect
          :hideDetails="true"
          :updateDetail="(c) => addEgkCode(c)"
        />
        <div v-for="(c,i) in selectedEgkCodes" class="flex mt-1 border pl-2 align-items-center bg-gray">
          <span class="flex-grow-1 pr-1">{{ c.title }}</span>
          <button @click="removeEgkCode(i)" class="btn btn-sm btn-default" type="button">
            <i class="icon-fa icon-fa-remove"/>
          </button>
        </div>
      </div>
      <div class="form-group">
        <label>Главный ключевик</label>
        <input v-model="taskData.drugDetails.main_keywords" type="text" class="form-control">
      </div>
      <div class="form-group">
        <label>Страна закупки</label>
        <select v-model="taskData.drugDetails.income_country_id" class="form-control">
          <option v-for="c in $AllCountries" :value="c.id">{{ c.name }}</option>
        </select>
      </div>

    </div>
    <div class="col-md-4 p-0 pl-1 pr-1">
      <label>
        <input type="checkbox" v-model="useRecipe"> Рецетурность
      </label>
      <template v-if="useRecipe">
        <div class="form-group">
          <label>Название на латыне</label>
          <input v-model="currentRecipe.lt_title" type="text" class="form-control">
        </div>
        <div class="flex">
          <div class="form-group flex-grow-1">
            <label>Применение</label>
            <input v-model="currentRecipe.signa" type="text" class="form-control">
          </div>
          <div class="form-group">
            <label>К-во уп. в рец.</label>
            <input v-model="currentRecipe.pack" type="number" class="form-control">
          </div>
          <div class="form-group">
            <label>Рец. дней</label>
            <input v-model="currentRecipe.days" type="number" class="form-control">
          </div>
        </div>
      </template>
      <div>
        <DiffPrices
          :prices="drugPrices"
          :updateRecords="(p) => drugPrices = p"
        />
      </div>
    </div>
  </div>
</template>

<script>

import EgkSelect from "@/views/nomenclature/components/details/EgkSelect.vue";
import DiffPrices from "@/views/nomenclature/components/DiffPrices.vue";

export default {
  components: {DiffPrices, EgkSelect},
  props: ['taskData'],
  data() {
    return {
      useRecipe: false,
      selectedEgkCodes: [],
      currentRecipe: {},
      drugPrices: [{
        qty: 1,
        price: 0,
        site_id: 1,
        margin: 0
      }]
    }
  },
  computed: {
    $AllCountries() {
      return this.$store.getters['platform/countries']
    },
  },
  created() {
    this.taskData.drugDetails = {
      ...this.taskData.drugDetails,
      priority: 1,
      details: {
        egk: [],
      }
    };
  },
  methods: {
    validate() {
      if (!this.taskData.drugDetails.title) return {success: false, message: 'Нет названия на платформе'};
      const data = {...this.taskData};
      if (this.useRecipe) {
        data.drugDetails.details.recipe = [{
          no_use: {type: 'int', value: +this.useRecipe},
          lt_title: {type: 'text', value: this.currentRecipe.lt_title},
          signa: {type: 'text', value: this.currentRecipe.signa},
          pack: {type: 'int', value: this.currentRecipe.pack},
          days: {type: 'int', value: this.currentRecipe.days},
        }];
      }
      data.drugDetails.details.egk = this.selectedEgkCodes.map((c) => {
        return {
          id: {type: 'int', value: c.id},
          title: {type: 'text', value: c.title}
        }
      });
      data.drugDetails.details.prices = this.drugPrices;
      return {success: true, data};
    },
    addEgkCode(code) {
      if (!this.selectedEgkCodes.find((c) => code.id === c.id)) {
        this.selectedEgkCodes.push(code);
      }
    },
    removeEgkCode(index) {
      delete this.selectedEgkCodes[index];
      this.selectedEgkCodes = this.selectedEgkCodes.filter((c) => c);
    }
  }
}

</script>
